import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

// Formatters (Portuguese Brazil)
export function formatDate(value) {
    if (!value) return "";
    try {
        const d = value instanceof Date ? value : new Date(value);
        return d.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    } catch {
        return "";
    }
}

export function formatDateTime(value) {
    if (!value) return "";
    try {
        const d = value instanceof Date ? value : new Date(value);
        return d.toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return "";
    }
}

export function formatCNPJ(value) {
    if (!value) return "";
    const s = String(value).replace(/\D/g, "");
    if (s.length !== 14) return value;
    return s.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

export function formatCPF(value) {
    if (!value) return "";
    const s = String(value).replace(/\D/g, "");
    if (s.length !== 11) return value;
    return s.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
}

export function formatPhone(value) {
    if (!value) return "";
    const s = String(value).replace(/\D/g, "");
    if (s.length === 11) return s.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    if (s.length === 10) return s.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
    return value;
}

export function initialsOf(name) {
    if (!name) return "?";
    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((p) => p[0])
        .join("")
        .toUpperCase();
}

// Build a full media URL from a relative /api/media/... path.
export function mediaUrl(relative) {
    if (!relative) return "";
    if (relative.startsWith("http")) return relative;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base.replace(/\/$/, "")}${relative.startsWith("/") ? relative : "/" + relative}`;
}

export function truncate(text, n = 40) {
    if (!text) return "";
    return text.length > n ? text.slice(0, n - 1) + "…" : text;
}

// Format number as Brazilian Real currency (BRL)
export function formatBRL(value) {
    const n = Number(value);
    if (Number.isNaN(n)) return "R$ 0,00";
    try {
        return n.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    } catch {
        return `R$ ${n.toFixed(2)}`;
    }
}
